import React, { Dispatch, SetStateAction, useState } from "react";
import ToggleBtn from "../ToggleBtn/ToggleBtn";
import { MagazineInter } from "../../interface/interface";
import { formatDate } from "../../lib/lib";
import FixBtn from "../FixBtn/FixBtn";
import PostDeleteSection from "../PostDeleteSection/PostDeleteSection";

type Props = {
  data: MagazineInter;
  DeleteIndex: string | undefined;
  index: number;
  setDeleteIndex: Dispatch<SetStateAction<string | undefined>>;
  PostRemove: (data: any, id: string) => void;
  PostStateChange?: (
    ctts_id: string,
    ctts_stat_cd: "ctts_sts_nrml" | "ctts_sts_none"
  ) => void;
};

const MagazineCard = ({
  data,
  DeleteIndex,
  index,
  setDeleteIndex,
  PostRemove,
  PostStateChange,
}: Props) => {
  const {
    ctts_ctg_nm,
    ctts_ctg_cd,
    ctts_reg_at,
    ctts_reg_login_nm,
    ctts_tit,
    ctts_ctts,
    ctts_id,
    reader_usr_info,
    ctts_stat_cd,
  } = data;

  return (
    <div className="magazine-card">
      <div className={`magazine-type ${ctts_ctg_cd}`}>
        {change[ctts_ctg_cd]}
      </div>
      <div className="magazine-title">{ctts_tit}</div>
      <div className="magazine-leader">{reader_usr_info}</div>
      <div className="magazine-timestamp">
        {formatDate(new Date(ctts_reg_at).getTime(), "-")}
      </div>
      <div className="magazine-show">
        <ToggleBtn
          isActive={ctts_stat_cd === "ctts_sts_none"}
          index={index}
          updateActive={() => {
            if (PostStateChange) {
              PostStateChange(
                ctts_id,
                ctts_stat_cd === "ctts_sts_none"
                  ? "ctts_sts_nrml"
                  : "ctts_sts_none"
              );
            }
          }}
        />
      </div>
      <div className="magazine-fix">
        <FixBtn
          link="/magazine/write/step/1"
          state={{ ctts_id }}
          style={undefined}
        />
      </div>
      <PostDeleteSection
        ment="매거진을 삭제하시겠습니까?"
        isOpen={DeleteIndex === ctts_id}
        index={ctts_id}
        setDeleteIndex={setDeleteIndex}
        data={{ ctts_ctts, ctts_tit }}
        PostRemove={PostRemove}
      />
    </div>
  );
};

export default MagazineCard;

const change = {
  MGN: "워크스토리",
  MGN_01: "월간 팀플리더",
  MGN_02: "팀플러 인터뷰",
};
